import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./edit.css";
import { defaultImage, url, urlImage, urlPhoto } from "../URLlist/urlList";
import ImagePhotos from "../imagePhotos/imagePhotos";
import { propsMassage } from "../massage/massage";

type props = {
	refresh: boolean;
	setRefresh: (e: boolean) => void;
	setMassage: (e: propsMassage) => void;
	setEdit: ({ visible, id }: { visible: boolean; id: string }) => void;
	id: string;
	setSpinner: (e: boolean) => void;
};

interface item {
	imie: string;
	nazwisko: string;
	date: string;
	userID?: string;
	id?: string;
	image?: string;
}

interface propsDate {
	dd: string | "";
	mm: string | "";
	rrrr: string | "";
}
function Edit({ id, refresh, setRefresh, setMassage, setEdit, setSpinner }: props) {
	const [item, setItem] = useState<item>({ imie: "", nazwisko: "", date: "", userID: "", id: "", image: "" });
	const [image, setImage] = useState<string | "">("");
	const [birthdayDate, setBirthdayDate] = useState<string | "">("");
	const refDate = useRef<HTMLInputElement>(null);
	const [disabled, setDisabled] = useState(true);

	useEffect(() => {
		setSpinner(true);
		try {
			fetch(url + id, {
				credentials: "include",
			})
				.then((res) => res.json())
				.then((res) => {
					const [{ imie, nazwisko, data_ur, userID, id, image }] = res;
					setBirthdayDate(data_ur);
					setItem({ imie, nazwisko, date: data_ur, userID, id, image });
				})
				.catch((err) => {
					setMassage({ text: "BŁĄD w pobraniu do edycji", type: "err" });
					setEdit({ visible: false, id: "" });
					setRefresh(!refresh);
				});
		} catch (error) {
		} finally {
			setSpinner(false);
		}
	}, []);

	useEffect(() => {
		item.image === "" ? setImage(defaultImage) : setImage(`${urlImage}${item.userID}/${item.image}`);
	}, [item.userID]);

	const sendPhoto = async (idItem: string) => {
		try {
			if (!image) return;
			const urlP = `${urlPhoto}/${idItem}`;

			const form = new FormData();
			const data = await (await fetch(image)).blob();

			form.append("file", data, `photo`);
			await fetch(urlP, {
				method: "POST",
				body: form,
				credentials: "include",
			});
		} catch (error) {
			console.log(error);
			setMassage({ text: "Błąd przy zapisie zdjecia - try again later", type: "err" });
		} finally {
			return;
		}
	};

	const validateData = () => {
		const thisYear = new Date().getFullYear();
		if (!birthdayDate.includes("-")) {
			setDisabled(true);
			return false;
		}
		const birthDayYear = Number(birthdayDate.split("-")[0]);
		console.log(birthDayYear);
		if (birthDayYear <= thisYear && item.imie !== "" && item.nazwisko !== "") {
			setDisabled(false);
			return true;
		} else {
			setDisabled(true);
			return false;
		}
	};

	function zapisz() {
		if (validateData()) {
			const newItem = { imie: item.imie, nazwisko: item.nazwisko, data_ur: birthdayDate };
			setSpinner(true);
			fetch(url + id, {
				method: "post",
				body: JSON.stringify(newItem),
				headers: { "Content-Type": "application/json" },
				credentials: "include",
			})
				.then((res) => {
					if (res.status === 202) {
						return res.json();
					} else {
						setMassage({ text: `Coś poszło nie tak`, type: "err" });
					}
				})
				.then(async (res) => {
					await sendPhoto(res.id);
					setMassage(res.msg);
				})
				.catch((err) => {})
				.finally(() => {
					setEdit({ visible: false, id: "" });
					setRefresh(!refresh);
					setSpinner(false);
				});
		} else {
			setMassage({ text: "Prosze wypełnić wszystkie pola", type: "err" });
		}
	}

	function anuluj() {
		setEdit({ visible: false, id: "" });
	}

	function deleteItem() {
		setSpinner(true);
		fetch(url + id, { method: "delete", credentials: "include" })
			.then((res) => {
				setMassage({ text: "Usunięto dane", type: "ok" });
			})
			.catch((err) => {
				console.log(err);
				setMassage({ text: "BŁĄD w Usunięciu danych", type: "err" });
			})
			.finally(() => {
				setEdit({ visible: false, id: "" });
				setSpinner(false);
				setRefresh(!refresh);
			});
	}

	return (
		<>
			<div className="editContainer">
				<div className="editContainerView">
					<span className={"editText"}>. . . Edycja danych . . . </span>
					<ImagePhotos image={image} setImage={setImage} setSpinner={setSpinner} />
					<div className="editView">
						<span className="editTextView">Imie</span>
						<input
							placeholder="IMIE"
							className={"editTextInput"}
							value={item.imie}
							onChange={(text) => {
								setItem({ ...item, imie: text.target.value });
							}}
						></input>
					</div>
					<div className="editView">
						<span className="editTextView">Nazwisko</span>
						<input
							type="text"
							placeholder="NAZWISKO"
							className="editTextInput"
							value={item.nazwisko}
							onChange={(text) => {
								setItem({ ...item, nazwisko: text.target.value });
								validateData();
							}}
						></input>
					</div>

					<div className="editView">
						<span className="editTextView">Data urodzenia</span>
						<div className="editViewData">
							<input
								type="date"
								onBlur={validateData}
								ref={refDate}
								aria-label="data_urodzenia"
								className="newDate"
								onChange={(e) => {
									setBirthdayDate(e.target.value);
								}}
								value={birthdayDate}
								max={new Date().toJSON().split("T")[0]}
							/>
						</div>
					</div>

					<div className="editButtons">
						<div>
							<button onClick={zapisz} disabled={disabled} className="editButton">
								Zapisz
							</button>
						</div>
						<div onClick={deleteItem}>
							<span className="editButton">Usuń</span>
						</div>
						<div onClick={anuluj}>
							<span className="editButton">Anuluj</span>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

// const styles = StyleSheet.create({
// 	model: {
// 		position: "absolute",
// 		top: 0,
// 		left: 0,
// 		right: 0,
// 		bottom: 0,
// 		justifyContent: "center",
// 		alignItems: "center",
// 		backgroundColor: "rgb(142, 184, 229)",
// 		zIndex: 1,
// 	},
// 	edycja: {
// 		fontSize: 16,
// 		fontWeight: "bold",
// 		marginBottom: 10,
// 	},
// 	text: {
// 		display: "flex",
// 		flex: 1,
// 		fontSize: 16,
// 		alignItems: "center",
// 		justifyContent: "center",
// 		fontWeight: "bold",
// 	},
// 	textInput: {
// 		display: "flex",
// 		flex: 2,
// 		borderWidth: 1,
// 		borderColor: "blue",
// 		padding: 5,
// 		paddingHorizontal: 15,
// 		fontWeight: "bold",
// 	},
// 	button1: {
// 		alignItems: "center",
// 		backgroundColor: "transparent",
// 		fontWeight: "bold",

// 		borderWidth: 1,
// 		borderRadius: 5,
// 		boxShadow: "0 0 3 3 white",
// 		paddingVertical: 8,
// 		paddingHorizontal: 25,
// 	},
// 	buttons1: {
// 		justifyContent: "space-between",
// 		alignItems: "center",
// 		marginTop: 10,
// 		marginBottom: 5,
// 		flexDirection: "row",
// 		width: "85%",
// 		alignSelf: "center",
// 	},
// 	view: {
// 		flexDirection: "row",
// 		width: "85%",
// 		borderColor: "blue",
// 		borderWidth: 1,
// 		padding: 10,
// 		justifyContent: "space-between",
// 		alignItems: "center",
// 		backgroundColor: "#7C99B4",
// 	},

// 	spinnerTextStyle: {
// 		color: "#FFF",
// 	},
// });
export default Edit;
